export function migrateSettingsState(value: unknown) {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return value
  const record = value as Record<string, unknown>
  const migrations =
    typeof record.migrations === "object" && record.migrations !== null && !Array.isArray(record.migrations)
      ? (record.migrations as Record<string, unknown>)
      : {}
  const controlRoom =
    typeof record.controlRoom === "object" && record.controlRoom !== null && !Array.isArray(record.controlRoom)
      ? (record.controlRoom as Record<string, unknown>)
      : undefined
  const nextControlRoom =
    migrations.desktopMiniChatDefault !== true && controlRoom
      ? { ...controlRoom, miniChat: true }
      : controlRoom
  const general =
    typeof record.general === "object" && record.general !== null && !Array.isArray(record.general)
      ? (record.general as Record<string, unknown>)
      : undefined
  const fileTreeGeneral = general?.showFileTree === false ? { ...general, showFileTree: true } : general
  const nextGeneral =
    migrations.followupQueueDefault !== true && fileTreeGeneral
      ? { ...fileTreeGeneral, followup: "queue" }
      : fileTreeGeneral
  const shouldWriteMigrations = nextControlRoom !== controlRoom || nextGeneral !== general
  if (!shouldWriteMigrations) return value

  return {
    ...record,
    ...(nextControlRoom !== controlRoom || nextGeneral !== general
      ? {
          migrations: {
            ...migrations,
            ...(nextControlRoom !== controlRoom ? { desktopMiniChatDefault: true } : {}),
            ...(nextGeneral !== general ? { followupQueueDefault: true } : {}),
          },
        }
      : {}),
    ...(nextControlRoom !== controlRoom ? { controlRoom: nextControlRoom } : {}),
    ...(nextGeneral !== general ? { general: nextGeneral } : {}),
  }
}
